import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import Heading from '../../Typography/Heading/Heading';
import styles from './ForgottenPassword.module.scss';
import { Field, Form, Formik } from 'formik';
import Modal from '../../Modal/Modal';
import { useTranslation } from 'react-i18next';
import TextError from '../../TextError/TextError';
import { firstLetterUpperCase } from '../../../helpers';
import TextInput from '../../Form/TextInput/TextInput';
import Button from '../../Button/Button';
import { recovery } from '../../../store/reducers/PasswordRecovery/passwordRecoverySlice';
import { Routes } from '../../../constants/routes';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForgottenPasswordSchema } from '../../../validations/forgotPassword';
import { setLinkSendModal, setForgotPasswordModal } from '../../../store/reducers/ModalsState/slice';
import cn from 'classnames';
import Loader from '../../Loader/Loader';
import { useDispatch, useSelector } from 'react-redux';
const ForgottenPassword = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { waitingForConfirmation, error, pending } = useSelector((state) => state.passwordRecovery);
    const useForgottenPasswordValidation = useForgottenPasswordSchema();
    const closeModal = () => {
        if (pathname === Routes.MY_ACCOUNT) {
            dispatch(setForgotPasswordModal(false));
        }
        else if (pathname === Routes.FORGOTTEN_PASSWORD) {
            navigate(Routes.HOME);
        }
    };
    useEffect(() => {
        if (waitingForConfirmation) {
            dispatch(setForgotPasswordModal(false));
            dispatch(setLinkSendModal(true));
            navigate(Routes.HOME);
        }
    }, [dispatch, navigate, t, waitingForConfirmation]);
    return (_jsxs(Modal, Object.assign({ background: true, className: cn(styles.element, 'position-relative'), closeModal: () => closeModal() }, { children: [_jsx(Heading, { size: 1, className: styles.heading, title: `${t('password_recovery')}?` }), _jsx(Formik, Object.assign({ initialValues: {
                    email: ''
                }, onSubmit: (values) => {
                    dispatch(recovery(values.email));
                }, validationSchema: useForgottenPasswordValidation }, { children: ({ handleChange, handleBlur, values, handleSubmit }) => (_jsxs(Form, Object.assign({ onSubmit: handleSubmit }, { children: [_jsx(Field, { label: t('email_address'), className: "w-100", type: "email", onChange: handleChange, onBlur: handleBlur, name: "email", id: "email", value: values.email, component: TextInput }), pending ? (_jsx(Button, { className: cn('w-100'), height: 'sm', size: '100', type: 'submit', text: "", icon: _jsx(Loader, {}) })) : (_jsx(Button, { height: 'sm', size: '100', type: "submit", text: t('reset_password') }))] }))) })), error && _jsx(TextError, { text: firstLetterUpperCase(error) })] })));
};
export default ForgottenPassword;
